export const FIRST_YEARLY_DELIVERY_DATE = '1/9/2024';
export const DATA_POINTS_LIMIT = 1_000_000;

export const DELETED_ACTION_HOVER_MESSAGE =
    "As a viewer, you don't have access to delete extracts. Reach out to your account admin to upgrade your member type to User.";
export const RESTORE_ACTION_HOVER_MESSAGE =
    "As a viewer, you don't have access to restore extracts. Reach out to your account admin to upgrade your member type to User.";
export const SCHEDULED_RESTORE_ACTION_HOVER_MESSAGE = 'Scheduled extracts cannot be restored.';
export const DAYS_PASSED_RESTORE_ACTION_HOVER_MESSAGE =
    'This extract can no longer be restored. It has been more than 30 days since it was deleted.';
export const DAYS_PASSED_DELETE_ACTION_HOVER_MESSAGE =
    'This extract can no longer be deleted. It has been more than 30 days since it was deleted.';